<template>
  <div style="width: 100%">
    <v-card>
      <template v-if="showSearchForm">
        <v-layout wrap>
          <v-flex xs6 class="px-3" style="display: flex; align-items: center">
            <h5 class="ma-0">{{ $t('Search') }}</h5>
          </v-flex>
          <v-flex xs6>
            <div class="text-xs-right">
              <v-btn flat fab :loading="loading" @click="$emit('close')">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>
        <v-card-text max-height="600">
          <div xs12 sm12>
            <div class="caption">ID</div>
            <div class="form-control"><input v-model="filter.id" type="number" /></div>
          </div>

          <div class="caption">Channel</div>
          <v-radio-group v-model="filter.channel" d-inline row>
            <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio>
            <v-radio class="mb-2" :value="'facebook'" color="primary" label="Facebook"></v-radio>
            <!-- <v-radio class="mb-2" :value="'line'" color="primary" label="Line"></v-radio> -->
            <v-radio class="mb-2" :value="'x'" color="primary" label="X"></v-radio>
            <v-radio class="mb-2" :value="'pantip'" color="primary" label="Pantip"></v-radio>
          </v-radio-group>

          <div class="caption">Page</div>
          <v-radio-group v-model="filter.search_page_id" d-inline row>
            <!-- <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio> -->
            <v-radio
              v-for="option in pageOptions"
              :key="option.value"
              class="mb-2"
              color="primary"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>

          <div class="caption">Platform Type</div>
          <v-radio-group v-model="filter.platform_type" d-inline row>
            <v-radio class="mb-2" :value="null" color="primary" :label="$t('All')"></v-radio>
            <v-radio
              class="mb-2"
              :value="'inbox'"
              color="primary"
              :label="$t('all_in_one_chat.inbox')"
            ></v-radio>
            <v-radio
              class="mb-2"
              :value="'page'"
              color="primary"
              :label="$t('all_in_one_chat.post')"
            ></v-radio>
          </v-radio-group>

          <div class="caption">
            Status
            <span
              style="text-decoration: underline; cursor: pointer; color: var(--primary-color)"
              @click="selectAllStatus"
              >({{
                filter.status && filter.status.length !== 6 ? $t('Select All') : $t('clear_all')
              }})</span
            >
          </div>
          <div class="mb-3">
            <v-checkbox
              v-model="filter.status"
              value="pending"
              label="Pending"
              color="primary"
              hide-details
            />
            <v-checkbox
              v-model="filter.status"
              value="answered"
              label="Answered"
              color="primary"
              hide-details
            />
            <v-checkbox
              v-model="filter.status"
              value="closed with survey"
              label="Closed with survey"
              color="primary"
              hide-details
            />
            <v-checkbox
              v-model="filter.status"
              value="closed without survey"
              label="Closed without survey"
              color="primary"
              hide-details
            />
            <v-checkbox
              v-model="filter.status"
              value="cancelled by customer"
              label="Cancelled by customer"
              color="primary"
              hide-details
            />
            <v-checkbox
              v-model="filter.status"
              value="closed by system"
              label="Closed by system"
              color="primary"
              hide-details
            />
          </div>

          <v-layout wrap>
            <v-flex xs12 class="px-1">
              <div class="caption">Topic</div>
              <div class="form-control">
                <input v-model="filter.subject" type="text" />
              </div>
            </v-flex>
            <v-flex xs12 sm12 class="px-1">
              <div class="caption">Customer name</div>
              <div class="form-control">
                <input v-model="filter.contact_name" type="text" />
              </div>
            </v-flex>
            <v-flex xs12 sm12 class="px-1">
              <div class="caption">Post ID</div>
              <div class="form-control">
                <input v-model="filter.postid" type="text" />
              </div>
            </v-flex>
            <v-flex xs12 sm12 class="px-1">
              <div class="caption">Thread ID</div>
              <div class="form-control">
                <input v-model="filter.thread_id" type="text" />
              </div>
            </v-flex>

            <v-flex xs12 sm12 class="px-1">
              <div class="caption">Group</div>
              <multiselect
                v-model="filter.group"
                class="mb-3"
                :disabled="['only_me', 'only_group', 'only_subgroup'].includes(view_ticket)"
                :options="agentGroupOptions"
                label="groupname"
                select-label
                selected-label
                :allow-empty="false"
                :searchable="false"
                deselect-label
                track-by="groupname"
                @input="onChangeGroup"
              ></multiselect>
            </v-flex>

            <template v-if="filter.group && filter.group.id != null">
              <v-flex xs12 sm6 class="px-1">
                <div class="caption">Sub Group</div>
                <multiselect
                  :key="`sub_${filter.group.id}`"
                  v-model="filter.subgroup"
                  class="mb-3"
                  :disabled="['only_me', 'only_subgroup'].includes(view_ticket)"
                  :options="agentSubGroupOptions"
                  label="subgroupname"
                  select-label
                  selected-label
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="subgroupname"
                ></multiselect>
              </v-flex>
              <v-flex xs12 sm6 class="px-1">
                <div class="caption">Assign To</div>
                <div class="form-control">
                  <multiselect
                    :key="`admin_${filter.group.id}`"
                    v-model="filter.admin"
                    class="mb-3"
                    :disabled="['only_me'].includes(view_ticket)"
                    :options="agentAdminOptions"
                    select-label
                    selected-label
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                  ></multiselect>
                </div>
              </v-flex>
            </template>
          </v-layout>

          <div class="px-1">
            <div class="caption">Priority</div>
            <multiselect
              :key="`priority`"
              v-model="filter.priority"
              class="mb-3"
              :options="priorityOptions"
              label="text"
              select-label
              selected-label
              :allow-empty="false"
              :searchable="false"
              deselect-label
              track-by="text"
            ></multiselect>
          </div>

          <div class="px-1">
            <div class="caption">Tags</div>

            <v-combobox
              v-model="tags"
              :filter="tagsfilter"
              :hide-no-data="!search"
              :items="items"
              :search-input.sync="search"
              hide-selected
              label="Search for an option"
              multiple
              small-chips
              solo
              flat
              outline
            >
              <template #no-data>
                <v-list-tile>
                  <span class="subheading">Create</span>
                  <v-chip :color="`primary lighten-3`" label small>{{ search }}</v-chip>
                </v-list-tile>
              </template>
              <template #selection="{ item, parent, selected }">
                <v-chip
                  v-if="item === Object(item)"
                  :color="`primary lighten-3`"
                  :selected="selected"
                  label
                  small
                >
                  <span class="pr-2">{{ item.text }}</span>
                  <v-icon small @click="parent.selectItem(item)">close</v-icon>
                </v-chip>
              </template>
              <template #item="{ index, item }">
                <v-list-tile-content>
                  <v-text-field
                    v-if="tagediting === item"
                    v-model="tagediting.text"
                    autofocus
                    flat
                    background-color="transparent"
                    hide-details
                    solo
                    @keyup.enter="tagsedit(index, item)"
                  ></v-text-field>
                  <v-chip v-else :color="`primary lighten-3`" label small>{{ item.text }}</v-chip>
                </v-list-tile-content>
                <v-spacer></v-spacer>
                <v-list-tile-action @click.stop>
                  <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                    <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </template>
            </v-combobox>
          </div>
          <v-divider class="my-2" />

          <div class="font-wight-bold mb-2">Ticket Date</div>

          <v-layout>
            <v-flex xs6>
              <div>
                <div class="caption">Start Date</div>
                <v-layout>
                  <v-flex xs10>
                    <DatePickerWithoutButton v-model="filter.selectedDate.start">
                      <div class="form-control">
                        <input type="text" :value="getDate(filter.selectedDate.start)" readonly />
                      </div> </DatePickerWithoutButton
                  ></v-flex>
                  <v-flex xs2>
                    <v-btn icon @click="filter.selectedDate.start = null">
                      <v-icon>close</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </div></v-flex
            >
            <v-flex xs6>
              <div>
                <div class="caption">End Date</div>
                <v-layout>
                  <v-flex xs10>
                    <DatePickerWithoutButton v-model="filter.selectedDate.end">
                      <div class="form-control">
                        <input type="text" :value="getDate(filter.selectedDate.end)" readonly />
                      </div> </DatePickerWithoutButton
                  ></v-flex>
                  <v-flex xs2>
                    <v-btn icon @click="filter.selectedDate.end = null">
                      <v-icon>close</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </div></v-flex
            >
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn block color="grey" outline :loading="loading" @click="clearSearch">
            {{ $t('Clear') }}
          </v-btn>
          <v-btn block color="primary" depressed :loading="loading" @click="onSearch">
            {{ $t('Search') }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </template>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'

export default {
  components: {
    Multiselect,
    DatePickerWithoutButton
  },
  props: ['value'],
  data() {
    return {
      filter: {},
      tempFilter: {},
      loading: false,
      view_ticket: '',
      tags: [],
      search: null,
      items: [{ header: 'Select an option or create one' }],
      tagediting: null,
      pageOptions: [
        { value: 'all', text: 'All' },
        ...this.$store.state.botlist.map((item) => ({ value: item.pageid, text: item.pagename }))
      ],
      priorityOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      // selectedDate: {
      //   start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      //   end: moment().format('YYYY-MM-DD'),
      //   starttime: null,
      //   endtime: null
      // },
      selectedDueDate: {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
      isMonix: 'isMonix',
      currentLang: 'currentLang'
    }),
    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null
            },
            ...this.agentGroup
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      const subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null
            },
            ...subgroup
          ]
    },
    agentAdminOptions() {
      let agents = []

      if (this.filter.group && this.filter.group.id) {
        agents = this.agents.filter((el) => {
          return el.admingroupid == this.filter.group.id
        })

        if (this.filter.subgroup && this.filter.subgroup.id) {
          agents = this.agents.filter((el) => {
            return el.adminsubgroupid == this.filter.subgroup.id
          })
        }
      } else {
        agents = this.agents
      }

      return agents.length > 0 ? agents.map((el) => el.adminid) : []
    },
    moment() {
      return moment
    },
    showSearchForm() {
      return Object.keys(this.filter).length > 0 ? true : false
    }
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.filter = this.value
      }
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }
          this.items.push(v)
        }
        return v
      })
    }
  },
  mounted() {
    if (this.value) {
      if (this.value.tags) {
        const tempTags = this.value.tags
        this.tags = tempTags.split(',')
      }
      this.filter = this.value
    }
  },
  methods: {
    formatFilter() {
      let data = {}

      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.id) {
        data.id = this.filter.id
      }
      if (this.filter.status) {
        data.status = this.filter.status
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }

      if (this.filter.group && this.filter.group.id != null) {
        data.assigngroupid = this.filter.group.id
      }

      if (this.filter.assignadminid) {
        data.assignadminid = this.filter.assignadminid
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.assignsubgroupid = this.filter.subgroup.id
      }

      if (this.filter.admin && this.filter.admin != null) {
        data.assignadminid = this.filter.admin
      }

      if (this.filter.selectedDate.start || this.filter.selectedDate.end) {
        data.selectedDate = {}
      }

      if (this.filter.selectedDate.start) {
        data.selectedDate.start = moment(this.filter.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.filter.selectedDate.end) {
        data.selectedDate.end = moment(this.filter.selectedDate.end).format('YYYY-MM-DD')
      }

      if (this.selectedDueDate.start) {
        data.startDueDate = moment(this.selectedDueDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDueDate.end) {
        data.endDueDate = moment(this.selectedDueDate.end).format('YYYY-MM-DD')
      }

      if (this.filter.priority && this.filter.priority.value != null) {
        data.priority = this.filter.priority.value
      }
      if (this.filter.sort && this.filter.sort.value != null) {
        data.orderby = this.filter.sort.value
      }
      if (this.filter.subject) {
        data.subject = this.filter.subject
      }
      if (this.filter.contact_name) {
        data.contact_name = this.filter.contact_name
      }
      if (this.filter.contact_email) {
        data.contact_email = this.filter.contact_email
      }

      if (this.filter.postid) {
        data.postid = this.filter.postid
      }

      if (this.filter.thread_id) {
        data.thread_id = this.filter.thread_id
      }

      if (this.filter.platform_type) {
        data.platform_type = this.filter.platform_type
      }

      if (this.filter.botreply == true || this.filter.botreply == false) {
        data.botreply = this.filter.botreply
      }

      if (this.tags && this.tags.length > 0) {
        var tags = this.tags.map((el) => {
          return el.text
        })
        data.tags = tags.join(',')
      }
      return data
    },
    async onSearch() {
      this.$emit('onSearch', this.filter)
    },
    clearSearch() {
      if (this.selectedBot.pageid == '101760532365601') {
        this.$refs['selcct-post'].clearPost()
      }
      this.filter = { ...this.tempFilter }
      this.filter.selectedDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
      this.selectedDueDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
      this.tags = []
      const filter = this.formatFilter()
      this.$emit('onSearch', filter)
    },
    onChangeGroup(val) {
      if (val.id) {
        this.$set(this.filter, 'subgroup', { id: null, subgroupname: 'All' })
      } else {
        this.$set(this.filter, 'subgroup', null)
      }
      this.$set(this.filter, 'admin', null)
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    getDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : ''
    },
    selectAllStatus() {
      if (this.filter.status && this.filter.status.length >= 6) {
        this.filter.status = []
        return
      }
      this.filter.status = [
        'pending',
        'answered',
        'closed with survey',
        'closed without survey',
        'cancelled by customer',
        'closed by system'
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/DialogSearchTicket.vue